// This file contains GeoJSON data for Tanzanian districts.
// In a real application, this might be fetched from an API or a static file server.
// Source: https://gadm.org/
// Note: This is a simplified version for demonstration purposes.

export const tanzaniaDistrictsGeoJSON = {
  "type": "FeatureCollection",
  "features": [
    // Arusha Region
    {
      "type": "Feature",
      "properties": { "REGION": "Arusha", "DISTRICT": "Arusha Urban" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 36.66, -3.36 ], [ 36.72, -3.35 ], [ 36.71, -3.42 ], [ 36.65, -3.41 ], [ 36.66, -3.36 ] ] ] }
    },
    {
      "type": "Feature",
      "properties": { "REGION": "Arusha", "DISTRICT": "Karatu" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 35.57, -3.30 ], [ 35.77, -3.30 ], [ 35.77, -3.45 ], [ 35.57, -3.45 ], [ 35.57, -3.30 ] ] ] }
    },
    {
      "type": "Feature",
      "properties": { "REGION": "Arusha", "DISTRICT": "Meru" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 36.75, -3.15 ], [ 36.95, -3.15 ], [ 36.95, -3.35 ], [ 36.75, -3.35 ], [ 36.75, -3.15 ] ] ] }
    },
    // Dar es Salaam Region
    {
      "type": "Feature",
      "properties": { "REGION": "Dar es Salaam", "DISTRICT": "Ilala" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 39.20, -6.77 ], [ 39.28, -6.77 ], [ 39.28, -6.85 ], [ 39.20, -6.85 ], [ 39.20, -6.77 ] ] ] }
    },
    {
      "type": "Feature",
      "properties": { "REGION": "Dar es Salaam", "DISTRICT": "Kinondoni" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 39.18, -6.72 ], [ 39.26, -6.72 ], [ 39.26, -6.80 ], [ 39.18, -6.80 ], [ 39.18, -6.72 ] ] ] }
    },
    {
      "type": "Feature",
      "properties": { "REGION": "Dar es Salaam", "DISTRICT": "Temeke" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 39.25, -6.86 ], [ 39.33, -6.86 ], [ 39.33, -6.94 ], [ 39.25, -6.94 ], [ 39.25, -6.86 ] ] ] }
    },
    {
      "type": "Feature",
      "properties": { "REGION": "Dar es Salaam", "DISTRICT": "Kigamboni" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 39.30, -6.80 ], [ 39.50, -6.80 ], [ 39.50, -7.00 ], [ 39.30, -7.00 ], [ 39.30, -6.80 ] ] ] }
    },
    {
      "type": "Feature",
      "properties": { "REGION": "Dar es Salaam", "DISTRICT": "Ubungo" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 39.10, -6.78 ], [ 39.20, -6.78 ], [ 39.20, -6.85 ], [ 39.10, -6.85 ], [ 39.10, -6.78 ] ] ] }
    },
    // Dodoma Region
    {
      "type": "Feature",
      "properties": { "REGION": "Dodoma", "DISTRICT": "Dodoma Urban" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 35.70, -6.15 ], [ 35.78, -6.15 ], [ 35.78, -6.23 ], [ 35.70, -6.23 ], [ 35.70, -6.15 ] ] ] }
    },
    {
      "type": "Feature",
      "properties": { "REGION": "Dodoma", "DISTRICT": "Chamwino" },
      "geometry": { "type": "Polygon", "coordinates": [ [ [ 36.00, -6.00 ], [ 36.30, -6.00 ], [ 36.30, -6.25 ], [ 36.00, -6.25 ], [ 36.00, -6.00 ] ] ] }
    },
    // Mwanza Region
    {
        "type": "Feature",
        "properties": { "REGION": "Mwanza", "DISTRICT": "Ilemela" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 32.90, -2.45 ], [ 33.00, -2.45 ], [ 33.00, -2.55 ], [ 32.90, -2.55 ], [ 32.90, -2.45 ] ] ] }
    },
    {
        "type": "Feature",
        "properties": { "REGION": "Mwanza", "DISTRICT": "Nyamagana" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 32.88, -2.55 ], [ 32.98, -2.55 ], [ 32.98, -2.65 ], [ 32.88, -2.65 ], [ 32.88, -2.55 ] ] ] }
    },
    // Mbeya Region
    {
        "type": "Feature",
        "properties": { "REGION": "Mbeya", "DISTRICT": "Mbeya Urban" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 33.40, -8.88 ], [ 33.50, -8.88 ], [ 33.50, -8.98 ], [ 33.40, -8.98 ], [ 33.40, -8.88 ] ] ] }
    },
    {
        "type": "Feature",
        "properties": { "REGION": "Mbeya", "DISTRICT": "Rungwe" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 33.55, -9.05 ], [ 33.75, -9.05 ], [ 33.75, -9.25 ], [ 33.55, -9.25 ], [ 33.55, -9.05 ] ] ] }
    },
    // Kilimanjaro Region
    {
        "type": "Feature",
        "properties": { "REGION": "Kilimanjaro", "DISTRICT": "Moshi Urban" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 37.32, -3.33 ], [ 37.37, -3.33 ], [ 37.37, -3.38 ], [ 37.32, -3.38 ], [ 37.32, -3.33 ] ] ] }
    },
    {
        "type": "Feature",
        "properties": { "REGION": "Kilimanjaro", "DISTRICT": "Hai" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 37.00, -3.20 ], [ 37.20, -3.20 ], [ 37.20, -3.40 ], [ 37.00, -3.40 ], [ 37.00, -3.20 ] ] ] }
    },
    // Tanga Region
    {
        "type": "Feature",
        "properties": { "REGION": "Tanga", "DISTRICT": "Tanga" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 39.05, -5.02 ], [ 39.15, -5.02 ], [ 39.15, -5.12 ], [ 39.05, -5.12 ], [ 39.05, -5.02 ] ] ] }
    },
    {
        "type": "Feature",
        "properties": { "REGION": "Tanga", "DISTRICT": "Korogwe" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 38.40, -5.10 ], [ 38.60, -5.10 ], [ 38.60, -5.25 ], [ 38.40, -5.25 ], [ 38.40, -5.10 ] ] ] }
    },
    // Zanzibar (Mjini Magharibi)
    {
        "type": "Feature",
        "properties": { "REGION": "Mjini Magharibi", "DISTRICT": "Mjini" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 39.18, -6.15 ], [ 39.23, -6.15 ], [ 39.23, -6.20 ], [ 39.18, -6.20 ], [ 39.18, -6.15 ] ] ] }
    }
  ]
};
